import React from "react";

export function useLatestRequest() {
  const versionRef = React.useRef(0);

  React.useEffect(() => () => { versionRef.current += 1; }, []);

  return React.useMemo(() => ({
    start() {
      versionRef.current += 1;
      return versionRef.current;
    },
    invalidate() {
      versionRef.current += 1;
    },
    isCurrent(version) {
      return versionRef.current === version;
    },
  }), []);
}
